export default __webpack_public_path__ + "static/media/23.da2c3a39.png";